import { getImageURL } from "../utils/getImageURL";
import { Author } from "../types/author";

export interface AuthorBioProps {
  author: Author;
}

export const AuthorBio = (props: AuthorBioProps) => {
  const { author } = props;

  if (!author.person) {
    return null;
  }

  const {
    person: { name, image },
    bio,
  } = author;

  return (
    <p className="text-body-2-medium mb-4">
      {image && (
        <img
          className="float-left mr-4 h-[128px] w-[128px] rounded-full"
          src={getImageURL(image).width(200).height(200).url()}
          alt=""
        />
      )}
      <span className="text-overline-1 text-black">{name}</span> {bio}
    </p>
  );
};
